var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('div',{staticClass:"loading-instituicao"},[_c('img',{attrs:{"src":"/public/img/loading-bar.gif"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }